import requset from "utils/request";
import baseURL from '@/api/env.js'
/*目标机构*/
export function authorlistTargetOrg(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/author/listTargetOrg`,
    method: "get",
    params
  });
}

/*申请奖项*/
export function inspectsign(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/sign`,
    method: "POST",
    data,
    hds: 2
  });
}
export function signfinaldownload(id, params) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/final/contract/download?bookId=${id}`,
    method: "GET",
    params
  });
}
// 添加邮箱
export function authoremail(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/author/modify/email`,
    method: "POST",
    params,
  });
}
// 合同数据查询
export function signcontractdownload(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/contract/download`,
    method: "POST",
    hds: 2,
    data,
  });
}
/* 作品列表 */
export function AuthorBookList(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/author/list`,
    method: "GET",
    params
  });
}
// // 获取完本状态
// export function getfinishbook(id) {
//   return requset({
//     url: `${baseURL.AHEAD}/book/book/finish/status/${id}`,
//     method: "GET"
//   });
// }
// 设置完本
export function finishbook(id) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/finish/${id}`,
    method: "GET"
  });
}
/*查询奖励*/
export function applyinfo(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/apply/info`,
    method: "GET",
    params
  });
}
/*申请奖项*/
export function applyadd(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/apply/add`,
    method: "POST",
    params
  });
}
/* 删除作品 */
export function delectbook(id) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/del/${id}`,
    method: "GET"
  });
}
/* 签约页面 */
export function getsigninfo(id) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/book/invited/${id}`,
    method: "GET"
  });
}
/* 签约作品管理 */
export function signBookList(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/sign/book/list`,
    method: "GET",
    params
  });
}
/* 作家监护人签名保存 */
export function parentSignSave(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/parentSignSave`,
    method: "post",
    data,
    hds: 2
  });
}
/* 上传身份证正面/护照 */
export function idCardSave(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/idCardSave`,
    method: "post",
    data,
    hds: 2
  });
};

/* 上传身份证反面 */
export function reqIdCardBackSave(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/idCardBackSave`,
    method: "post",
    data,
    hds: 2
  });
};
/* 分类列表===创建作品 */
export function sortList() {
  return requset({
    url: `${baseURL.AHEAD}/book/book/sort/type`,
    method: "GET"
  });
}
/* 添加作品 */
export function addbook(data) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/add`,
    method: "POST",
    data
  });
}
/* 获取tags列表 */
export function tagslist() {
  return requset({
    url: `${baseURL.AHEAD}/book/book/tag/list`,
    method: "GET"
  });
}
/* 查询编辑列表 */
export function getEditorsList() {
  return requset({
    url: `${baseURL.AHEAD}/author/author/editor/list`,
    method: 'get'
  });
}
/* 修改作品信息 */
export function editbook(params, bookid) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/edit/${bookid}`,
    method: "POST",
    params
  });
}
/* 根据作品id获取可编辑信息 */
export function getbookinfo(bookid) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/edit/${bookid}`,
    method: "get"
  });
}
/********************章节************************/
/* 根据作品id获取作品信息 */
export function bookInfo(bookid) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/${bookid}`,
    method: "get"
  });
}

/* =====发布作品 */
export function publishBook(bookid) {
  return requset({
    url: `${baseURL.AHEAD}/book/book/open/${bookid}`,
    method: "get"
  });
}
// ==获取章节内容
export function getEditCon(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/chapter/edit`,
    method: "get",
    params
  });
}
// 获取章节列表
export function getchapterlist(bookid) {
  return requset({
    url: `${baseURL.AHEAD}/book/chapter/list/${bookid}`,
    method: "get",
  });
}
// 修改章节信息
export function editChapter(data) {
  return requset({
    url: `${baseURL.AHEAD}/chapter/edit`,
    method: "POST",
    data
  });
}

/* =====发布章节 */
// 发布新章节
export function publishChapter(data) {
  return requset({
    url: `${baseURL.AHEAD}/book/chapter/add`,
    method: "POST",
    data
  });
}
// 修改章节
export function publishOldChapter(data) {
  return requset({
    url: `${baseURL.AHEAD}/book/chapter/edit`,
    method: "POST",
    data
  });
}
// 获取已发布章节目录
export function getPublishVo(bookid) {
  return requset({
    url: `${baseURL.AHEAD}/chapter/list/${bookid}`,
    method: "get"
  });
}
// 删除章节
export function delChapter(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/chapter/delete`,
    method: "post",
    params
  });
}
// 查看作家稿费
export function authorpayloglist(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/author/paylog/list`,
    method: "GET",
    params
  });
}
// 查看作家稿费提现
export function authorapply(params) {
  return requset({
    url: `${baseURL.AHEAD}/author/apply/withdrawal`,
    method: "post",
    params
  });
}
/* ================================作品签约 */
// 获取作家基本信息
export function getNormalInfo() {
  return requset({
    url: `${baseURL.AHEAD}/author/author/info`,
    method: "GET"
  });
}
// 修改基本信息
export function changeNormalInfo(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/author/modify`,
    method: "POST",
    data
  });
}

/* 获取作品签约信息 */
export function getSignInfo(bookId) {
  return requset({
    url: `${baseURL.AHEAD}/book/invited/${bookId}`,
    method: "GET"
  });
}

// 身份证验证
export function checkidNo(params) {
  return requset({
    url: `${baseURL.AHEAD}/book/author/verify_page`,
    method: "POST",
    params
  });
}
/* 发送邮箱验证码 */
export function sendCode(data) {
  return requset({
    url: `${baseURL.AHEAD}/sendCode`,
    method: "POST",
    data
  });
}
// 签约
export function signBook(data) {
  return requset({
    url: `${baseURL.AHEAD}/author/sign/inspect/addFirst`,
    method: "POST",
    data
  });
}

// 绑定主账号
export function bindMainId(data) {
  return requset({
    url: `${baseURL.AHEAD}/accounts/bundle/author`,
    method: "POST",
    data
  });
}
/*子账号绑定申请审核  */
export function isbindpass(data) {
  return requset({
    url: `${baseURL.AHEAD}/accounts/bundle/inspect`,
    method: "POST",
    data
  });
}
/*取消绑定 */
export function canclebind() {
  return requset({
    url: `${baseURL.AHEAD}/accounts/bundle/cancle`,
    method: "POST"
  });
}
// 是否能变更账户
export function ischangeMainId() {
  return requset({
    url: `${baseURL.AHEAD}/accounts/author/modify`,
    method: "GET"
  });
}
// 变更账户
export function changeMainId(data) {
  return requset({
    url: `${baseURL.AHEAD}/accounts/author/modify`,
    method: "POST",
    data
  });
}
/*/==========================无用*/
/* ================草稿箱*/
//==获取章节目录
export function draftChapters(params) {
  return requset({
    url: `${baseURL.AHEAD}/chapter/draftChapters`,
    method: "get",
    params
  });
}
